<template>
    <div
        class="editorShapeElement"
        style="width: 100%; height: 100%;"
    >
        <inline-svg
            :alt="el.name"
            :src="el.path"
            :fill="el.isOutline ? 'none' : `#${el.color.hex}`"
            :stroke="el.isOutline ? `#${el.color.hex}` : 'none'"
            style="display: block; width: 100%; height: 100%;"
        />
    </div>
</template>

<script>
    export default {
        props: ['el']
    }
</script>

<style lang="scss" scoped>
</style>